import { ActionTypes } from '../Constants/actionTypes'
import api from '../../api/interceptor'
import apiTransaction from '../../api/interceptorTransaction'
import captureException from '../../utils/SentryHelper'
import { handleLogout } from '../../App'


export const handleAuthError = (error) => {
  if ((error?.response?.status === 401 || error?.response?.status === 403) && error?.response?.data?.detail === "Authentication credentials were not provided.") {
    handleLogout()
  }
}

export const getProfile = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await api.get('prerequisites/')
      dispatch({ type: ActionTypes.GET_PROFILE, payload: res?.data })
      dispatch({ type: ActionTypes.LOADING_FAIL })
      return res
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      return error?.response?.status
    }
  }
}

export const getPayoutSumarry = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await api.get('payoutsummary/')
      dispatch({ type: ActionTypes.PAYOUT_SUMMARY, payload: res })
      dispatch({ type: ActionTypes.LOADING_FAIL })
      return res
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
    }
  }
}

export const getMarketingData = () => {
  return async (dispatch) => {
    dispatch({ type: ActionTypes.LOADING_SUCCESS2 })
    try {
      const res = await api.get('marketing/permissions/')
      dispatch({ type: ActionTypes.GET_MAKETING_DATA, payload: res })
      dispatch({ type: ActionTypes.LOADING_FAIL2 })
      return res
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL2 })
      console.log({ error })
    }
  }
}

export const getMonthsLimit = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await api.get('loans/termlimit/')
      // getMonth(res?.data, LoanAmount)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      return res?.data
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
    }
  }
}

export const getAvailableBanks = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await apiTransaction.get('banks/available/')
      dispatch({ type: ActionTypes.GET_BANKS, payload: res.data })
      dispatch({ type: ActionTypes.LOADING_FAIL })
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
    }
  }
}
export const getAffordability = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await api.get('prerequisites/v2/affordability/')
      dispatch({ type: ActionTypes.GET_AFFORDIBILITY, payload: res.data })
      dispatch({ type: ActionTypes.LOADING_FAIL })
      return res
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
    }
  }
}

export const createAffordability = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await api.post('prerequisites/v2/affordability/', payload)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      return res
    } catch (error) {
      handleAuthError(error)
      captureException(error, payload)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
      return error.response
    }
  }
}

export const getTruelayerTerms = () => {
  return async (dispatch) => {
    try {
      // dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await api.get('reference/doc/truelayer/')
      dispatch({ type: ActionTypes.GET_TERMS, payload: res.data })
      dispatch({ type: ActionTypes.LOADING_FAIL })
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
    }
  }
}
export const getApplications = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await api.get('loans/applications/?include_accepted=true')
      dispatch({
        type: ActionTypes.ADD_AND_GET_APPLICATOION,
        payload: res.data,
      })
      dispatch({ type: ActionTypes.LOADING_FAIL })
      // localStorage.setItem('AppStatus', res?.data[0]?.status)
      return res
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
    }
  }
}

export const getApplicationsErrorHandling = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await api.get('loans/applications/?include_accepted=true')
      dispatch({ type: ActionTypes.LOADING_FAIL })
      // localStorage.setItem('AppStatus', res?.data[0]?.status)
      return res
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
      window.location.href = '/error'
    }
  }
}

export const Account_Management_List = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await api.get('loan/get_loan_account_management_list/')
      dispatch({ type: ActionTypes.LOADING_FAIL })
      dispatch({ type: ActionTypes.LOAN_MANAGEMENT, payload: res?.data[0] ? res?.data[0] : [] })
      const maxExternalIdObject = res?.data?.reduce((maxObj, currentObj) => {
        const maxExternalId = parseInt(maxObj?.external_id, 10)
        const currentExternalId = parseInt(currentObj?.external_id, 10)
        if (isNaN(currentExternalId)) return maxObj
        if (isNaN(maxExternalId)) return currentObj
        return currentExternalId > maxExternalId ? currentObj : maxObj
      }, res?.data?.[0] ? res?.data?.[0] : [])
      return maxExternalIdObject ? maxExternalIdObject : []
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
    }
  }
}

export const getSoftsearchDocs = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await api.get('reference/doc/softsearch/')
      dispatch({ type: ActionTypes.GET_SOFT_SEARCH, payload: res?.data?.html })
      dispatch({ type: ActionTypes.LOADING_FAIL })
      return res?.data?.html
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
    }
  }
}

export const upateApplications = (id, data, setError) => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await api.patch(`loans/applications/${id}/`, data)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      return res
    } catch (error) {
      handleAuthError(error)
      captureException(error, data)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
      setError(error?.response?.data?.detail)
    }
  }
}

export const ConnectBank = (provider_id, setConnect) => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS2 })
      const res = await apiTransaction.get(
        `connect/?provider_id=${provider_id}&platform=web`,
      )
      setConnect(res?.data?.new)
      dispatch({ type: ActionTypes.LOADING_FAIL2 })
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL2 })
      console.log({ error })
    }
  }
}

export const getAccountsBasic = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await apiTransaction.get('profile/accounts/')
      dispatch({ type: ActionTypes.LOADING_FAIL })
      return res?.data
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
    }
  }
}

export const getAccounts = (setstep, setAccountLoading, email = null) => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      setAccountLoading(true)
      const res = await apiTransaction.get('profile/dd_accounts/')
      const accounts = res?.data
      const unexpiredAccounts = (accounts ? accounts : []).filter(account => (account?.days_to_renew ? account?.days_to_renew : 0) > 0)
      if (unexpiredAccounts.length > 0) {
        if (!localStorage.getItem(`add-another-bank-account-${email}`) === true) {
          setstep(3)
        }
      }
      if (res) {
        const refresh = await dispatch(refreshAccounts())
        if (refresh) {
          setAccountLoading(false)
          dispatch({ type: ActionTypes.LOADING_FAIL })
        }
      }
      // dispatch({ type: ActionTypes.GET_DD_ACCOUNTS, payload: res.data })
    } catch (error) {
      handleAuthError(error)
      setAccountLoading(false)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
    }
  }
}
export const getAccountsonDD = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      // setAccountLoading(true)
      const res = await apiTransaction.get('profile/dd_accounts/')
      dispatch({ type: ActionTypes.LOADING_FAIL })
      return res?.data
    } catch (error) {
      handleAuthError(error)
      // setAccountLoading(false)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
    }
  }
}

export const getDdAccounts = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await apiTransaction.get('profile/dd_accounts/')
      dispatch({ type: ActionTypes.LOADING_FAIL })
      const temp = res?.data?.find((_i) => _i?.days_to_renew > 0)
      return temp ? temp?.days_to_renew : null
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
    }
  }
}

export const refreshAccounts = () => {
  return async (dispatch) => {
    try {
      // dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await apiTransaction.get('profile/accounts/refresh/')
      const accounts = res?.data
      const unexpiredAccounts = (accounts ? accounts : []).filter(account => (account?.days_to_renew ? account?.days_to_renew : 0) > 0)
      dispatch({ type: ActionTypes.GET_DD_ACCOUNTS, payload: unexpiredAccounts })
      // dispatch({ type: ActionTypes.LOADING_FAIL })
      return res
    } catch (error) {
      handleAuthError(error)
      // dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
    }
  }
}

export const getDirectDebitGDocs = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await api.get(`reference/doc/ddterms/`)
      dispatch({
        type: ActionTypes.GET_DIRECT_DEBIT_G,
        payload: res?.data?.html,
      })
      dispatch({ type: ActionTypes.LOADING_FAIL })
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
    }
  }
}

export const getIntercomHashUser = (token) => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const headers = token ? { Authorization: `JWT ${token}` } : {}
      const res = await api.get('intercom/hmac/', { headers })
      dispatch({ type: ActionTypes.LOADING_FAIL })
      return res
    } catch (error) {
      if (!token) {
        handleAuthError(error)
      }
      dispatch({ type: ActionTypes.LOADING_FAIL })
      // not that important, just log it
      console.log({ error })
    }
  }
}

export const getAgreementDocs = (id, type, actionType) => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await api.get(`loans/applications/${id}/agreement/${type}/`)
      dispatch({
        type: actionType,
        payload: res?.data?.html,
      })
      dispatch({ type: ActionTypes.LOADING_FAIL })
      return res?.data?.html
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      // console.log({ error });
    }
  }
}

export const fetchApplicationStatus = () => {
  return async () => {
    try {
      const res = await api.get(`loans/application/status/`)
      return res?.data
    } catch (error) {
      handleAuthError(error)
    }
  }
}

export const getReApply = () => {
  return async (dispatch) => {
    dispatch({ type: ActionTypes.LOADING_SUCCESS })
    const status = await dispatch(fetchApplicationStatus())
    if (status) {
      dispatch({
        type: ActionTypes.RE_APPLY,
        payload: status.reapply,
      })
      dispatch({
        type: ActionTypes.GET_APPLICATION_STATUS,
        payload: status,
      })
    }
    dispatch({ type: ActionTypes.LOADING_FAIL })
    return status
  }
}

export const getDecision = (la_id, token) => {
  return async (dispatch) => {
    try {
      dispatch({ type: ActionTypes.LOADING_SUCCESS })
      const res = await api.get(
        `aggregator/user/application/decision/${la_id}/`,
        {
          headers: {
            'Authorization': `JWT ${token}`,
          },
        }
      )
      dispatch({ type: ActionTypes.LOADING_FAIL })
      dispatch({
        type: ActionTypes.ADD_AND_GET_APPLICATOION,
        payload: [res?.data?.application],
      })
      return res
    } catch (error) {
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })

      /* if (error?.response?.status === 401 || error?.response?.status === 403 || error?.response?.status === 404) {
        // authentication failed (invalid or expired token)
        // TODO: here; have user login with force opened login popup
        return error?.response
      } */
        return error?.response
    }
  }
}

export const getIsOurCustomer = () => {
  return async (dispatch) => {
    
    dispatch({ type: ActionTypes.LOADING_SUCCESS2 })
    try {
      const res = await api.get('marketing/customer/')
      dispatch({ type: ActionTypes.GET_IS_OUR_CUSTOMER, payload: res?.data?.is_our_customer })
      dispatch({ type: ActionTypes.LOADING_FAIL2 })
      return res?.data?.is_our_customer
    } catch (error) {
      await new Promise(r => setTimeout(r, 3000))

      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL2 })
      console.log({ error })

      return false
    }
  }
}

export const getReasonsList = () => {
  return async (dispatch) => {
    
    dispatch({ type: ActionTypes.LOADING_SUCCESS })
    try {
      const res = await api.get('loans/application/reasons/')
      dispatch({ type: ActionTypes.LOADING_FAIL })
      return res?.data
    } catch (error) {
      handleAuthError(error)
      dispatch({ type: ActionTypes.LOADING_FAIL })
      console.log({ error })
    }
  }
}